

'use strict';

const ConfigMap = new Map();
ConfigMap.set("local", 
// 포트는 CMS_Back/config/dev/api.json 의 port 와 일치해야 한다 (run/local.js 가 config/dev 를 로드).
{backendUrl: "http://localhost:10025", cmsUrl: "http://localhost:2200/cms", cdnUrl: `http://prism-dev.day7games.com/`, title: "local", isDev: true, displayTitle: "로컬 CMS", });

// development: nginx가 /api/ 를 백엔드(config/dev/api.json)로 프록시 → 같은 호스트(443)로 요청
ConfigMap.set("development",
    {backendUrl: `https://${window.location.hostname}`, cmsUrl: "http://localhost:2200/cms", cdnUrl: `http://cmsdev.pnjstudio.com/`, title: "dev", isDev: true, displayTitle: "개발 CMS",});


// live 도 nginx /api/ 프록시를 경유한다. cms_back 은 평문 HTTP 로 뜨고 TLS 는 nginx 가 종단한다.
ConfigMap.set("live",
    {backendUrl: `https://${window.location.hostname}`, cmsUrl: "http://localhost:2200/cms", cdnUrl: `http://cms.pnjstudio.com/`, title: "live", isDev: false, displayTitle: "라이브 서비스 실서버", });

// function getMode()
// {
//     let mode = process.env.NODE_ENV;
//     console.log(`getMode: ${mode}`);
//     if (process.env.NODE_ENV === 'production')
//     {
//         mode = 'live';   
//     }
//     else{
//         mode = 'local';
//     }
//     //mode = 'live';
//     return mode;
// }
function getMode() {
    const host = window?.location?.hostname || '';
    if (host === 'localhost' || host === '127.0.0.1' || host === '::1') {
        return 'local';
    }
    // cms.pnjstudio.com 인 경우에만 라이브
    if (host === 'cms.pnjstudio.com') {
        return 'live';
    }
    // cmsdev.pnjstudio.com, dev.*, staging.*, 기타 → development
    return 'development';
}

function getConfig()
{
    console.log(`mode: ${getMode()}`);
    return ConfigMap.get(getMode());
}

export default {
    isDev: (() => {
        return getMode() =='development';
        //return getConfig().isDev;
    })(),
    isLocal: (() => {
        return getMode() === 'local';
    })(),
    isQa: (() => {
        return getMode() === 'qa' || getMode() === 'qa_global';
    })(),
    isQaGlobal: (() => {
        return getMode() === 'GLOBAL';
    })(),    
    isLive: (() => {
        return getMode() === 'live';
    })(),
    getBackendUrl: (() => {
        console.log(`ENV: ${process.env.NODE_ENV} BackEndUrl: ${getConfig().backendUrl}`);
        return getConfig().backendUrl; 
    })(),
    getCndUrl: (() => {
        console.log(`ENV: ${process.env.NODE_ENV} CdnUrl: ${getConfig().cdnUrl}`);
        return getConfig().cdnUrl; 
    })(),
    getServerTypeToString: (() => {
        //return `${getConfig().title}(${process.env.NODE_ENV})`;
        return getConfig().title;
    })(),
    getDisplayText: (() => {
        return getConfig().displayTitle;
    })(),
    s3_ImgQuizBucket: (() => {
        return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/";
    })(),
    // 프롬프트 마스터 — local/dev 환경에서만 사용
    promptMaster_URL: (() => {
        let mode = getMode();
        if (mode === 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/prombook/manage/live/PromptMaster.json";
        }
        return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/prombook/manage/dev/PromptMaster.json";
    })(),
    promptMaster_S3_KEY: (() => {
        let mode = getMode();
        if (mode === 'live') {
            return "prombook/manage/live/PromptMaster.json";
        }
        return "prombook/manage/dev/PromptMaster.json";
    })(),
    // 프롬프트 리스트는 마스터 설정과 별도 파일로 관리 (운영 책임 분리)
    promptList_URL: (() => {
        let mode = getMode();
        if (mode === 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/prombook/manage/live/PromptList.json";
        }
        return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/prombook/manage/dev/PromptList.json";
    })(),
    promptList_S3_KEY: (() => {
        let mode = getMode();
        if (mode === 'live') {
            return "prombook/manage/live/PromptList.json";
        }
        return "prombook/manage/dev/PromptList.json";
    })(),
    serverState_URL_CPU: (() => {
        //return getMode() === 'qa' || getMode() === 'qa_global';
        let mode = getMode();
        if(mode == 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/project_cpu/manage/live/ServerState.json";
        }
        else{
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/project_cpu/manage/dev/ServerState.json";
        }
    })(),
    serverState_URL_QUIZ_N_CASH: (() => {
        //return getMode() === 'qa' || getMode() === 'qa_global';
        let mode = getMode();
        if(mode == 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/quizcash/manage/live/ServerState.json";
        }
        else{
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/quizcash/manage/dev/ServerState.json";
        }
    })(),
    serverState_URL_CARRY_GOLD: (() => {
        //return getMode() === 'qa' || getMode() === 'qa_global';
        let mode = getMode();
        if(mode == 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/carrygold/manage/live/ServerState.json";
        }
        else{
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/carrygold/manage/dev/ServerState.json";
        }
    })(),
    serverState_URL_PNT_FACTORY: (() => {
        let mode = getMode();
        if(mode == 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/pnt_factory/manage/live/ServerState.json";
        }
        else{
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/pnt_factory/manage/dev/ServerState.json";
        }
    })(),
    serverState_URL_MANDOORA: (() => {
        let mode = getMode();
        if(mode == 'live') {
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/mandoora/manage/live/ServerState.json";
        }
        else{
            return "https://content-filecenter.s3.ap-northeast-2.amazonaws.com/mandoora/manage/dev/ServerState.json";
        }
    })(),    


};